import { render, staticRenderFns } from "./LeadWizardStandaloneApp.vue?vue&type=template&id=1a88e00b&"
import script from "./LeadWizardStandaloneApp.vue?vue&type=script&lang=js&"
export * from "./LeadWizardStandaloneApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports